<template>
  <section class="section is-main-section">
    <form @submit.prevent="formAction" class="box">
      <card-component
        title="Documentação do Dispositivo"
        icon="file"
        style="border: 1px solid lightgray"
      >
        <!-- AUTORIZAÇÃO -->
        <b-field
          v-if="!temAutorizacao"
          label="Autorização para utilização do dispositivo"
        >
          <file-picker v-model="form.autorizacao.file" type="is-info" />
        </b-field>

        <b-field v-if="!temEmail" label="E-mail de autorização">
          <file-picker v-model="form.email.file" type="is-info" />
        </b-field>

        <br />

        <b-field>
          <div class="control">
            <b-button native-type="submit" type="is-info" :loading="isLoading">
              Enviar
            </b-button>
          </div>
        </b-field>

        <br />
      </card-component>
    </form>

    <b-progress v-if="isLoading" size="is-medium" type="is-info" show-value>
      Enviando arquivos...
    </b-progress>
  </section>
</template>

<script>
import CardComponent from "@/components/Cards/CardComponent.vue";
import FilePicker from "@/components/FilePicker.vue";
import DocumentoService from "@/services/DocumentoService";

export default {
  name: "FormDocumentosDispositivo",

  components: {
    CardComponent,
    FilePicker,
  },

  data() {
    const dataAtual = new Date().toISOString().split("T")[0];
    return {
      isLoading: false,
      idAcessoDispositivo: null,
      documentos: [],

      form: {
        autorizacao: {
          data: dataAtual,
          file: null,
          tipo: "TERMO_AUTORIZACAO_DISPOSITIVO",
          idAcessoDispositivo: null,
        },

        email: {
          data: dataAtual,
          file: null,
          tipo: "AUTORIZACAO_DOP",
          idAcessoDispositivo: null,
        },
      },
    };
  },

  computed: {
    idDispositivo() {
      return this.$route.params.id;
    },

    temAutorizacao() {
      return this.documentos.some(
        (doc) => doc.tipo === "TERMO_AUTORIZACAO_DISPOSITIVO"
      );
    },

    temEmail() {
      return this.documentos.some((doc) => doc.tipo === "AUTORIZACAO_DOP");
    },
  },
  async mounted() {
    const id = this.$route.params.id;

    if (!id) {
      this.$buefy.toast.open({
        message: "ID do dispositivo não encontrado!",
        position: "is-bottom",
        type: "is-danger",
      });

      return;
    }

    this.idAcessoDispositivo = Number(id);

    this.form.autorizacao.idAcessoDispositivo = this.idAcessoDispositivo;
    this.form.email.idAcessoDispositivo = this.idAcessoDispositivo;

    try {
      const response = await DocumentoService.getDocumentosAcessoDispositivo(
        this.idAcessoDispositivo
      );

      this.documentos = response.data || [];
    } catch (error) {
      console.error("ERRO AO BUSCAR DOCUMENTOS:", error);
    }
  },
  methods: {
    async formAction() {
      this.isLoading = true;

      try {
        const idAcessoDispositivo =
          this.idDispositivo || this.form.autorizacao.idAcessoDispositivo;

        if (!idAcessoDispositivo) {
          throw new Error("ID do dispositivo não encontrado.");
        }

        this.form.autorizacao.idAcessoDispositivo = idAcessoDispositivo;
        this.form.email.idAcessoDispositivo = idAcessoDispositivo;

        if (this.form.autorizacao.file) {
          await DocumentoService.postDocumento(this.form.autorizacao);
        }

        if (this.form.email.file) {
          await DocumentoService.postDocumento(this.form.email);
        }

        this.$buefy.toast.open({
          message: "Documentos enviados com sucesso!",
          position: "is-bottom",
          type: "is-success",
        });

        await this.$router.push({
          name: "FormDispositivos.edit",
          params: {
            id: idAcessoDispositivo,
          },
        });
      } catch (error) {
        console.error("ERRO AO ENVIAR DOCUMENTOS:", error);

        if (error.response) {
          console.error("STATUS:", error.response.status);
          console.error("RESPOSTA:", error.response.data);
        }

        this.$buefy.toast.open({
          message:
            error.response?.data?.message ??
            error.message ??
            "Erro ao enviar documentos!",
          position: "is-bottom",
          type: "is-danger",
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
